import { useCallback, MutableRefObject } from 'react';

/**
 * Prevents duplicate async calls using a ref guard.
 * Skips execution if already in-flight, otherwise runs and resets when complete.
 */
export function useGuardedAsync(fetchingRef: MutableRefObject<boolean>) {
  return useCallback(
    <T>(action: Promise<T>, onFinally?: () => void) => {
      if (fetchingRef.current) return;

      fetchingRef.current = true;

      return action.finally(() => {
        fetchingRef.current = false;
        onFinally?.();
      });
    },
    [fetchingRef],
  );
}